import { InspectorControls } from '@wordpress/block-editor';
import { TabPanel } from '@wordpress/components';

// Settings Components
import { tabController, updateData } from '../../../../../bpl-tools/utils/functions';
import { generalStyleTabs } from '../../../utils/options';
import General from './General/General';
import Style from './Style/Style';

const Settings = props => {
	const { attributes, setAttributes } = props;

	// update object 
	const updateObject = (attr, key, val) => {
		const newAttr = { ...attributes[attr] };
		newAttr[key] = val;
		setAttributes({ [attr]: newAttr })
	}

	const updateObj = (property, val, ...props) => {
		setAttributes({ [property]: updateData(attributes[property], val, ...props) });
	}

	return <>
		<InspectorControls>

			<TabPanel className='bPlTabPanel' activeClass='activeTab' tabs={generalStyleTabs} onSelect={tabController}>{tab => <>
				{'general' === tab.name && <>
					<General {...props} updateObj={updateObj} updateObject={updateObject} />
				</>}

				{'style' === tab.name && <>
					<Style {...props} updateObj={updateObj} updateObject={updateObject} />
				</>}
			</>}</TabPanel>
		</InspectorControls>
	</>;
};
export default Settings;